import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ICreateVenueBody } from './types';

export const createVenue = (requestBody: ICreateVenueBody): Promise<any> => {
  const url = `${API_URL}/venues`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
